import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IDetailedFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
  featuresCount: number;
  usersCount: number;
}

export const showFeatureGroupsByKeyService = async (
  featureGroupKey: string,
): Promise<IDetailedFeatureGroup | null> => {
  const { data } = await jhsfBookingsApi.get<IDetailedFeatureGroup>(
    '/feature-groups/find-by-key',
    {
      params: {
        featureGroupKey,
      },
    },
  );

  return data;
};
